import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { MenuLeftIcon } from '@iris/react-icons/MenuLeftIcon';
import { MenuRightIcon } from '@iris/react-icons/MenuRightIcon';
import { isSameMonth, endOfMonth, isBefore, startOfMonth, isAfter } from 'date-fns';
import styles from '../Calendar.styles.esm.js';
import { cn } from '../../../utils/cn.esm.js';

const CalendarHeader = forwardRef(({ calendarDate, currentDate, disablePastDates, disableFutureDates, disablePastTo, disableFutureFrom, onPreviousMonth, onNextMonth, inverse = false, }, ref) => {
    const { header, headerDate, headerControlContainer, headerControlItem, headerControlItemIcon, } = styles({
        inverse,
    });
    return (jsxs("div", { ref: ref, className: header(), children: [jsx("div", { className: cn(headerDate()), children: calendarDate.toLocaleString("default", {
                    month: "long",
                    year: "numeric",
                }) }), jsxs("div", { className: headerControlContainer(), children: [jsx("button", { className: cn(headerControlItem()), onClick: onPreviousMonth, "aria-label": "Go to previous month", disabled: (disablePastDates && isSameMonth(calendarDate, currentDate)) ||
                            (disablePastTo
                                ? (() => {
                                    const disablePastToDate = endOfMonth(new Date(disablePastTo));
                                    return isBefore(calendarDate, disablePastToDate);
                                })()
                                : false), children: jsx(MenuLeftIcon, { className: cn(headerControlItemIcon(), "iris:pr-(--base-space-px-2)") }) }), jsx("button", { className: cn(headerControlItem()), onClick: onNextMonth, "aria-label": "Go to next month", disabled: (disableFutureFrom
                            ? (() => {
                                const disableFutureFromDate = startOfMonth(new Date(disableFutureFrom));
                                return isAfter(disableFutureFromDate, calendarDate);
                            })()
                            : false) ||
                            (disableFutureDates && isSameMonth(calendarDate, currentDate)), children: jsx(MenuRightIcon, { className: cn(headerControlItemIcon(), "iris:pl-(--base-space-px-2)") }) })] })] }));
});

export { CalendarHeader };
